import React from 'react';
import { Reveal } from './Reveal';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const testimonials: Testimonial[] = [{
  initials: 'SR',
  quote: 'I planned my entire month of step classes in one Sunday afternoon. I walked into class Monday morning knowing exactly what to do, which patterns to teach, and how to correct every mistake. My students felt the difference immediately.',
  name: 'Sarah R.',
  role: 'Los Angeles, CA · Step & Group Fitness Instructor'
}, {
  initials: 'JM',
  quote: 'I had a student with knee issues and honestly didn’t know how to adapt the class safely. Volume 4 gave me the exact low-impact protocols. Now I handle every modification with complete confidence and zero hesitation.',
  name: 'Jessica M.',
  role: 'Austin, TX · Step & Cardio Instructor'
}, {
  initials: 'KP',
  quote: 'I used to spend hours every week searching for choreography ideas. Now I open the drill bank, choose the sequence, print the sheet, and I’m done in 5 minutes. It completely changed how I prepare for class.',
  name: 'Karen P.',
  role: 'London, UK · Group Fitness & Step Instructor'
}];
export function TestimonialStrip() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-220" data-mp="208tkqwhz9sj2">
      <div className="mx-auto max-w-6xl" data-id="element-221" data-mp="1vez2lxi0tlm3">
        <Reveal className="text-center" data-id="element-222" data-mp="1ve77ensc5pwc">
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl" data-id="element-223" data-mp="296ndxykg4620">
            ⭐ What Instructors Are <span className="text-green-dark" data-id="element-224" data-mp="2551xk38pd9n2">Saying</span>
          </h2>
          <p className="mt-4 text-slate" data-id="element-225" data-mp="2j5uromv3e2pn">Professionals who now teach every step class with a real system.</p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-226" data-mp="2e7t69va71rb0">
          {testimonials.map((item, index) => <Reveal key={item.initials} delay={index * 0.05} data-id="element-227" data-mp="os3itpkl7mv9" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-ink/10 bg-mist p-8 shadow-premium" data-id="element-228" data-mp="jta7o3srw7y9">
                <div className="text-green" data-id="element-229" data-mp="2jw1mvdkclz19">★★★★★</div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-230" data-mp="2ottfyawqbr71">“{item.quote}”</blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-231" data-mp="2svog3c2xbyj8">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sky text-sm font-bold text-teal" data-id="element-232" data-mp="2sxrd4g2hurxg">
                    {item.initials}
                  </span>
                  <span data-id="element-233" data-mp="32rhz9eb5eq9z">
                    <span className="block font-bold text-ink" data-id="element-234" data-mp="37sp3x4hzv9cf">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-235" data-mp="37qcfc8hqe0qe">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}